<!-- Product Details Dialog -->
<p-dialog [(visible)]="showProductDialog" [modal]="true" [closable]="true" [header]="'productDetailsDialog.artworkDetails' | transloco"
  [style]="{ maxWidth: '90vw', width: '800px' }" class="shadow-lg rounded-3" (onHide)="closeDialog()">
  @if (selectedProduct) {
    <div class="container-fluid">
      <div class="row gx-4 gy-4 align-items-start">
        <!-- Left Side: Artwork Image -->
        <div class="col-12 col-md-5 d-flex justify-content-center">
          <div class="card border-0 rounded-3 shadow-sm position-relative w-100" style="max-width: 400px;">
            @if (selectedProduct.ArtistRevenue) {
              <span class="badge position-absolute top-0 start-0 m-3 fs-6 text-white rounded-pill"
                style="background-color: #178d9b; z-index: 10;">
                {{ selectedProduct.ArtistRevenue | currency: 'USD':'symbol':'1.2-2' }}
              </span>
            }
            <img
              [src]="selectedProduct.ProductImgUrl ? selectedProduct.ProductImgUrl : 'assets/images/No-Image.png'"
              [alt]="'productDetailsDialog.artworkImage' | transloco"
              class="img-fluid rounded-3 shadow"
              style="aspect-ratio: 1 / 1; width: 100%; height: auto; object-fit: contain;">
            </div>
          </div>
          <!-- Right Side: Artwork Details -->
          <div class="col-12 col-md-7">
            <div class="d-flex flex-column h-100 justify-content-between">
              <div>
                <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h4 class="text-uppercase fw-bold mb-0 text-dark">
                    {{ selectedProduct.Name || 'Untitled Artwork' }}
                    <span class=" text-secondary"> - ({{ selectedProduct.SerialNumber || 'N/A' }})</span>
                  </h4>
                  <small class="fst-italic text-muted">{{ selectedProduct.CreatedDate | date: 'dd/MM/yyyy' }}</small>
                </div>
                @if (selectedProduct.ArtTypeDto?.Name) {
                  <div class="mb-1 d-flex flex-wrap align-items-center gap-2">
                    <label class="mb-0 fs-5 fw-semibold text-muted">{{ 'productDetailsDialog.artType' | transloco }}</label>
                    <span class=" text-secondary">{{ selectedProduct.ArtTypeDto.Name }}</span>
                  </div>
                }
                <p class="text-muted mb-2">{{ selectedProduct.ArtistShortDescription || 'No description available.' }}</p>
                <h6 class="fs-5 fw-semibold text-muted mb-2">{{ 'productDetailsDialog.artworkInformation' | transloco }}</h6>
                <div class="mb-2 d-flex flex-wrap gap-2">
                  @if (selectedProduct.CategoryDto?.Name) {
                    <div class="text-truncate">
                      <span class="fw-semibold text-muted">{{ 'productDetailsDialog.category' | transloco }}</span>
                      <span class="text-secondary ms-1">{{ selectedProduct.CategoryDto.Name || 'N/A' }}</span>
                    </div>
                  }
                  @if (selectedProduct.SeriesDto?.Name) {
                    <div class="text-truncate">
                      <span class="fw-semibold text-muted">{{ 'productDetailsDialog.series' | transloco }}</span>
                      <span class="text-secondary ms-1">{{ selectedProduct.SeriesDto.Name || 'N/A' }}</span>
                    </div>
                  }
                  @if (selectedProduct.ClayDto?.Name) {
                    <div class="text-truncate">
                      <span class="fw-semibold text-muted">{{ 'productDetailsDialog.material' | transloco }}</span>
                      <span class="text-secondary ms-1">{{ selectedProduct.ClayDto.Name || 'N/A' }}</span>
                    </div>
                  }
                </div>
                @if (selectedProduct.ProductGlazeDto?.length > 0) {
                  <div class="mb-2">
                    <div class="fw-semibold text-muted mb-2">{{ 'productDetailsDialog.features' | transloco }}</div>
                    <div class="d-flex flex-wrap gap-2">
                      @for (glaze of selectedProduct.ProductGlazeDto; track glaze) {
                        <span
                          class="badge bg-secondary text-truncate"
                          style="max-width: 140px; white-space: nowrap;"
                          pTooltip="{{ glaze.Description || 'No description available.' }}"
                          tooltipPosition="bottom">
                          {{ glaze.Name }}
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
              <div>
                <h6 class="fs-5 fw-semibold text-muted mb-3">{{ 'productDetailsDialog.dimensions' | transloco }}</h6>
                <div class="row text-center text-md-start">
                  <div class="col-6 col-sm-3 mb-3 mb-sm-0">
                    <div class="fs-6 fw-bold">{{ selectedProduct.Height || 'N/A' }} cm</div>
                    <small class="text-muted">{{ 'productDetailsDialog.height' | transloco }}</small>
                  </div>
                  <div class="col-6 col-sm-3 mb-3 mb-sm-0">
                    <div class="fs-6 fw-bold">{{ selectedProduct.Width || 'N/A' }} cm</div>
                    <small class="text-muted">{{ 'productDetailsDialog.width' | transloco }}</small>
                  </div>
                  <div class="col-6 col-sm-3 mb-3 mb-sm-0">
                    <div class="fs-6 fw-bold">{{ selectedProduct.Length || 'N/A' }} cm</div>
                    <small class="text-muted">{{ 'productDetailsDialog.depth' | transloco }}</small>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="fs-6 fw-bold">{{ selectedProduct.Weight || 'N/A' }} kg</div>
                    <small class="text-muted">{{ 'productDetailsDialog.weight' | transloco }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </p-dialog>

